import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { Asset } from "types/Asset";
import { Reducer } from "react";

export interface WaveformData {
  data: number[];
  sample_rate: number;
  samples_per_pixel: number;
  bits: number;
  length: number;
}

export const waveformApi = createApi({
  reducerPath: "waveforms",
  baseQuery: fetchBaseQuery({ baseUrl: "/" }),
  tagTypes: ["Asset"],
  endpoints: (builder) => ({
    getWaveformData: builder.query({
      queryFn: async (asset: Asset) => {
        // dynamic import to avoid circular dependency
        const { default: gatewayFetch } = await import(
          "utilities/gatewayFetch"
        );
        if (!asset.waveformUrl) {
          return { data: undefined };
        }
        const urlResponse = await gatewayFetch(asset.waveformUrl, {});
        const { url: expiringUrl } = await urlResponse.json();
        const waveformResponse = await fetch(expiringUrl);
        const data: WaveformData = await waveformResponse.json();
        return {
          data,
        };
      },
      providesTags: (_result, _error, arg) => [{ type: "Asset", id: arg.id }],
    }),
  }),
});

export type WaveformApiState =
  typeof waveformApi.reducer extends Reducer<infer S, infer _>
    ? S | undefined
    : never;

export const initialWaveformApiState: WaveformApiState = {} as WaveformApiState;
